import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import Paginate from 'vuejs-paginate'
import Loader from './../shared/loader'
import Pagination from './../shared/pagination'
import Vue from "vue";
import JsonExcel from "vue-json-excel";
import download from 'downloadjs';
import csvHelper from '../reports/importjsontocsv';
import DatePicker from 'vue2-datepicker'
import moment from 'moment'

Vue.component("downloadExcel", JsonExcel);
export default {
	name: 'wipInventory',
	components: {
		Paginate,
		Loader,
		Pagination,
		JsonExcel,
		download,
		DatePicker
	},

	data: function() {
		return {
			totalPage: 0,
			totalRows: 0,
			currentPage: 1,
			pageLimit: 5,  //pagination for popup tables
			isLoading: false,
            listClientData: [],
			listWarehouseData: [],
			client: '',
			clientid: '',
			warehouse: '',
			warehouseid: '',
			showSelectClient: false,
			showSelectWarehouse: false,
			ClientErr: '',
			WarehouseErr: '',
			limitExeed:false,
			download: true,
			listReportDataforxls: [],
			csvFieldsForXls: {},
			csvFields:{},
			reportname: '',
			token: '',
			channellist : [],
			resultCount:0,
			formattedDate: '',
			selectedRow:null,
			selectedRows: {},
			useremail:'',
            stocktype: '',
            eancode: '',
			listGRNData: [],
			listPutawayData: [],
			listPackingData: [],
			listShippingData: [],
			show: false,
			download: true,
			allocationResultData: [],
			showGRNDetails: false,
			showReturnsDetails: false,
			showPODetails: false,
			showPutawayBucketDetails: false,
			showPutawayPoDetails: false,
			showPutawayReturnsDetails: false,
			showPutawayCancelDetails: false,
			showPutawayMoveOrderDetails: false,
			showPackingBucketDetails: false,
			showPackingSalesOrderDetails: false,
			showPackingRTVDetails: false,
			showPackingGatepassDetails: false,
			showShippingBucketDetails: false,
			showShippingSalesOrderDetails: false,
			showShippingRTVDetails: false,
			showShippingGatepassDetails: false,
			isLoadingforxls: false,
			InGRNBucketDetails: false,
			InPackingBucketDetails: false,
			InPutawayBucketDetails:false,
			InShippingBucketDetails:false,
			searchFlag: false,
			packingSalesData: [],
			PackingSalesDataTotalPages: 0,
			listWipInventoryData: [],
			packingRTVData: [],
			packingGatepassData: [],
			packingSalesOrderDataCSV: [],
			EANNo: '',
			totalPageInPackingOrder: 0,
			totalRowsInPackingOrder:0,
			totalRowsInPackingGetpass: 0,
			totalPageInPackingGetpass: 0,
			currentPageInPackingGetpass: 1,
			currentPageInPackingOrder: 1,
			currentPageInPackingRtv: 1,
			totalRowsInPackingRTV:0,
			totalPageInPackingRTV:0,
			totalRowsInGRNPo: 0,
			totalPageInGRNPo: 0,
			currentPageInGRNPo:1,
			totalRowsInGRNReturns: 0,
			totalPageInGRNReturns: 0,
			currentPageInGRNReturns:1,
			totalRowsInPutawayPo: 0,
			totalPageInPutawayPo: 0,
			currentPageInPutawayPo: 1,
			totalRowsInPutawayReturns: 0,
			totalPageInPutawayReturns: 0,
			currentPageInPutawayReturns:1,
			totalRowsInPutawayCancel: 0,
			totalPageInPutawayCancel: 0,
			currentPageInPutawayCancel:1,
			totalRowsInPutawayMoveOrder: 0,
			totalPageInPutawayMoveOrder: 0,
			currentPageInPutawayMoveOrder:1,
			totalRowsInShippingGetpassData: 0,
			totalPageInShippingGetpassData: 0,
			currentPageInShippingGetpassData:1,
			totalRowsInShippingOrderData: 0,
			totalPageInShippingOrderData: 0,
			currentPageInShippingOrderData:1,
            GRNPOData: [],
			GRNReturnsData: [],
			inPutawayPoData: [],
			inPutawayCancelOrder: [],
			inPutawayMoveorder: [],
			inPutawayReturnsData: [],
            inShippingGetpassData: [],
			inShippingOrderData: [],
			inShippingRTVData:[],
			totalQtyInBucket: {},
			currentPage1: 1,
			pageLimit1: 10,
			bucketType: '',
			totalBucketCount: {
				grn : 0,
				putaway: 0,
				packing: 0,
				shipping: 0,
				totalInventory: 0
			},
			skuNo: '',
			dataFilter2: [],
			listWipSummarycsv: [],
			sku:'',
			eancode:'',
			eancode1:'',
			showAlldetails:true,
            selectbucketwise :false,
			listBucketwiseDataforxls:[],
		}
	},
	filters: {
		moment: function(date) {
			return moment(date).format('DD-MM-YYYY');
		}
	},
    created: function() {},
	mounted() {
		var permissionEncrypt = window.localStorage.getItem('userdetail');
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.userid = userdetail.userid;
		this.useremail=userdetail.email;
		var userToken = window.localStorage.getItem('userToken')
		this.token = userToken.replace(/"/g, '')
		this.pageno = 0;
	    var today = new Date();
		this.reportname = this.$t('wipInventory.wipInventorySummaryReport');
		this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
		this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss')
		this.user_type = userdetail.utype;
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
	
		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				// this.getClientList();
			    // this.getWarehouseList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				this.client = this.clientid;
				// this.getWarehouseList();
				this.showSelectWarehouse = true;
				break;

			case 'warehouse_user':
				this.loginUserEmail = userdetail.email;
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				this.showSelectClient = true;
				// this.getClientList();

				var roleids = userdetail.roleid.split(',');
				for (var i = 0; i < roleids.length; i++) {
					if (roleids[i] == 40) {
						this.purchasingManager = parseInt(roleids[i]);
					}
					if (roleids[i] == 41) {
						this.isInwardUserForPO = true;
					}
				}
				break;

			default:
				this.$alertify.error(this.$t('common.unauthorisedError'));
				break
		}

	},
	methods: {
		
		// getWarehouseList() {
		// 	this.pageNo = 0;

		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseData = JSON.parse(plaintextwarehouse);
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.pageNo = 0;
		// 		this.input = ({
		// 			clientid: this.clientid,
		// 		});

		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr
		// 			}
		// 		})
		// 			.then(result => {
		// 				this.listWarehouseData = result.data.data;
		// 			}, error => {
		// 				console.error(error)
		// 			})
		// 	}
		// },

		// getClientList() {
		// 	this.pageNo = 0;
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');

		// 		this.input = ({
		// 			warehouseid: this.warehouseid,
		// 		});

		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr,
		// 			}
		// 		})
		// 			.then(result => {
		// 				this.listClientData = result.data.data;
		// 			}, error => {
		// 				console.error(error);
		// 			});
		// 	}
		// },

		// clientSelected() {
		// 	if (this.clientid != this.client) {
		// 		this.clientid = this.client;
		// 		if (this.user_type != 'warehouse_user') {
		// 			this.listWarehouseData = []
		// 			this.getWarehouseList();
		// 			if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
		// 				this.warehouse = this.warehouseid = '';
		// 			} else {
		// 				this.warehouse = ''
		// 			}
		// 		} else {
		// 			if (this.warehouseid && this.clientid);
					
		// 		}
		// 	}
		// 	this.pageNo = this.totalPage = 0;
		// },

		// warehouseSelected() {
		// 	this.warehouseid = this.warehouse;
		// 	this.pageno = this.totalPage = 0;
		// 	if (this.warehouseid) {
		// 		if (this.clientid) {
				
		// 		} else {
		// 			this.getClientList();
		// 		}
		// 	}
		// },
		Choosetype2() {
			this.show = true;
			this.download = false;
			this.getWipSummaryForXLS();
		},
		Choosetype1(bucketType,csvdata) {
			this.show = true;
			this.download = false;
			if(bucketType){
				this.downloadbucketwisewipReport(bucketType,csvdata)
			}
		},
		startDownload() {
			this.isLoadingforxls = true;
		},
		finishDownload() {
			this.isLoadingforxls = false;
		},
		calculateTotalWipCount(data) {
			return Number(data.grnpendingqty)+  Number(data.putawaypedningqty) + Number(data.packpedningqty) + Number(data.shippedningqty) ;
		  },
		calculateBucketWiseCount(data){
                    this.totalBucketCount["grn"]= Number(data.grnpendingqtysum);
					this.totalBucketCount["putaway"]= Number(data.putawaypedningqtysum);
					this.totalBucketCount["packing"]= Number(data.packpedningqtysum);
					this.totalBucketCount["shipping"]= Number(data.shippedningqtysum);
					let totalSum=0;
					Object.keys(this.totalBucketCount).forEach(key=>{
						if(key !== "totalInventory"){
							totalSum += this.totalBucketCount[key];
						}
					})
					this.totalBucketCount["totalInventory"]=totalSum;
		},
		getWipSummaryForXLS(){
            var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.show = true;
			this.download = false;
			this.dataFilter2 = [];
			var value = '';
			var str = '';
            let params ={
				clientid: window.localStorage.getItem('selectedClient'),
				warehouseid: window.localStorage.getItem('selectedWarehouse'),
				eancode: this.eancode?this.eancode:null,
				stocktype: this.stocktype?this.stocktype:null,
			};
			Object.entries(params).forEach(([k, v]) => {
				let skipkeys = [];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					value += k + ':' + v + ','
					this.dataFilter2 = str.concat(value);

				}
			});
			axios({
				method: 'GET',
				url: `${apiUrl.api_url}wipproducts`,
				params: params,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
			.then(response => {
					if (response.data.count > 0) {
						this.listWipInventoryReportDataforxls = [];
						this.csvFieldsForXls =[];
						this.csvFieldsForXls[this.$t('orders.skuID')] = 'productid',
						this.csvFieldsForXls[this.$t('common.ean')] = 'eancode',
						this.csvFieldsForXls[this.$t('wipInventory.totalWipInventory')]= 'totalWipInventory',
						this.csvFieldsForXls[this.$t('wipInventory.inGrn')] = 'grnpendingqty',
						this.csvFieldsForXls[this.$t('wipInventory.inPutaway')] = 'putawaypedningqty',
						this.csvFieldsForXls[this.$t('wipInventory.inPacking')] = 'packpedningqty',
						this.csvFieldsForXls[this.$t('wipInventory.inShipping')] = 'shippedningqty',
					
						this.listWipInventoryReportDataforxls = response.data.data.map((el) => {return { productid:el.productid,eancode:el.eancode,'totalWipInventory':Number(el.grnpendingqty)+Number(el.packpedningqty)+Number(el.shippedningqty)+Number(el.putawaypedningqty),grnpendingqty:el.grnpendingqty,putawaypedningqty:el.putawaypedningqty,packpedningqty:el.packpedningqty,shippedningqty:el.shippedningqty}});

					} 
			}, error => {
				console.error(error);
			})

		},
		showgrndetails(eancode,btype,data ={}){
         
		   this.showReturnsDetails= true
           this.EANNo = eancode
		   this.skuNo = data.clientproductid
		   switch (btype) {
			case 'in_packing_order':
				this.showPackingBucketDetails = true;
			  this.showPackingSalesOrderDetails = true
			  this.showPackingRTVDetails=false
			  this.showPackingGatepassDetails=false

			  break;
			case 'in_packing_rtv':
				this.showPackingBucketDetails = true;
			this.showPackingRTVDetails=true
			this.showPackingGatepassDetails=false
			this.showPackingSalesOrderDetails = false


			  break;
			case 'in_packing_getpass':
			this.showPackingBucketDetails = true;
			this.showPackingRTVDetails=false
			this.showPackingGatepassDetails=true
			this.showPackingSalesOrderDetails = false
			  break;
			case 'in_grn_po':
				this.showGRNDetails = true
				this.showReturnsDetails = false 
                this.showPODetails = true
			 break;
			case 'in_grn_returns':
				this.showGRNDetails = true
				this.showReturnsDetails = true 
                this.showPODetails = false
			 break;
			 case 'in_putaway_po':
				this.InPutawayBucketDetails = true
			 break;
			case 'in_putaway_returns':
				this.InPutawayBucketDetails = true
			break;

			case 'in_putaway_cancle_modify':
				this.InPutawayBucketDetails = true
			break;
			case 'in_putaway_moveorder':  
				this.InPutawayBucketDetails = true
			break;
			case 'in_shipping_getpass':
				this.showShippingGatepassDetails = true
				this.InShippingBucketDetails = true
				this.showShippingSalesOrderDetails= false
				this.showShippingRTVDetails = false
				this.showSalesOrder = false
				this.showrtvorder = false
				this.showgatepass = true
			break;
			case 'in_shipping_order':
				this.InShippingBucketDetails = true
				this.showShippingSalesOrderDetails= true
				this.showShippingRTVDetails = false
				this.showShippingGatepassDetails = false
				this.showSalesOrder = true
				this.showrtvorder = false
				this.showgatepass = false
			break;
			case 'in_shipping_rtv':
			    this.showShippingRTVDetails = true

				this.InShippingBucketDetails = false
				this.showShippingSalesOrderDetails= true
				this.showShippingGatepassDetails = false
				this.showSalesOrder = false
				this.showrtvorder = true
				this.showgatepass = false
			// Add more cases for other bucket types if needed
		  }
		   
		   this.wipproductdetailsfunction(eancode,btype)
		},

		showWipInventorySummary(csvCheck=0){
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var dataFilter = {};
			this.searchFlag=true;
			if (csvCheck == 2) {
				this.show = false;
				this.download = true;
			}
			if (window.localStorage.getItem('selectedClient')==='undefined') {
				this.$alertify.error(this.$t('common.clientError'))
				this.totalPage = 0;
				this.listWipInventoryData = [];
				return false;
			}
			if (window.localStorage.getItem('selectedWarehouse')==='undefined') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.totalPage = 0;
				this.listWipInventoryData = [];
				return false;
			}
          
			this.isLoading = true;

			let params= {
				clientid: window.localStorage.getItem('selectedClient'),
				warehouseid: window.localStorage.getItem('selectedWarehouse'),
				eancode: this.eancode?this.eancode:null,
				stocktype: this.stocktype?this.stocktype:null,
			}
			if (csvCheck !== 1) {
				params.offset = (this.currentPage1 - 1) * this.pageLimit1;
				params.limit = this.pageLimit1;
			}
			Object.entries(params).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					dataFilter[k] = v;
				}
			})
			axios({
				method: 'GET',
				url: `${apiUrl.api_url}wipproducts`,
				params: params,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
			.then(response=>{
				if (csvCheck == 1) {
					this.show = true;
					this.download = false;
					this.listWipSummarycsv = [];
					this.csvFields = {
						'eancode': this.$t('common.ean'),
						'productid': this.$t('orders.skuID'),
						'totalWipInventory':this.$t('wipInventory.totalWipInventory'),
						'grnpendingqty': this.$t('wipInventory.inGrn'),
						'packpedningqty': this.$t('wipInventory.inPacking'),
						'shippedningqty': this.$t('wipInventory.inShipping'),
						'putawaypedningqty': this.$t('wipInventory.inPutaway'),
					};
					
					this.listWipSummarycsv = response.data.data.map((el) => {return { productid:el.productid,eancode:el.eancode,'totalWipInventory':Number(el.grnpendingqty)+Number(el.packpedningqty)+Number(el.shippedningqty)+Number(el.putawaypedningqty),grnpendingqty:el.grnpendingqty,putawaypedningqty:el.putawaypedningqty,packpedningqty:el.packpedningqty,shippedningqty:el.shippedningqty}});
					var dateFilter = [];
					var skipFilter = ['sumcount','packpedningqtysum','shippedningqtysum','grnpendingqtysum','putawaypedningqtysum','rowcount'];
					csvHelper.data.jsonToCSV(this.$t('wipInventory.wipInventorySummaryReport'), this.listWipSummarycsv, this.csvFields, dateFilter, skipFilter, dataFilter);

				} else{
					if(response.data.status==false){
                        this.resultCount = 0;
						this.totalRows = 0;
						this.listWipInventoryData=[];
						this.totalBucketCount={
							grn : 0,
							putaway: 0,
							packing: 0,
							shipping: 0,
							totalInventory: 0
						};
						this.$alertify.error(response.data.msg);
					}
                   else{
					if(response.data.count>0){
					this.listWipInventoryData = response.data.data;
					this.calculateBucketWiseCount(this.listWipInventoryData[0]);
                    this.isLoading = false;
					this.totalRows = response.data.count;
					this.resultCount = response.data.count;
					if (this.totalRows < this.pageLimit1) {
						this.totalPage = 1;
					} else {
						this.totalPage = Math.ceil(this.totalRows / this.pageLimit1);
					}
				 }
				 else{
					    this.resultCount = 0;
						this.totalRows = 0;
						this.listWipInventoryData=[];
						this.totalBucketCount={
							grn : 0,
							putaway: 0,
							packing: 0,
							shipping: 0,
							totalInventory: 0
						};
				 }
				}
				}
				 this.isLoading = false;
			})
			.catch(error => {
				console.error(error);
			});
		},
		showWipInventorySummary1(){
			this.currentPage1 = 1;
			this.showWipInventorySummary(2);
			
		},
		showBucketWiseProducts(csvCheck=0, bucketType){
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var dataFilter = {};
			this.searchFlag=true;
			if (csvCheck == 2) {
				this.show = false;
				this.download = true;
			}
			if (window.localStorage.getItem('selectedClient')==='undefined') {
				this.$alertify.error(this.$t('common.clientError'))
				this.totalPage = 0;
				this.listWipInventoryData = [];
				return false;
			}
			if (window.localStorage.getItem('selectedClient')==='undefined') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.totalPage = 0;
				this.listWipInventoryData = [];
				return false;
			}
          
			this.isLoading = true;

			let params= {
				clientid: window.localStorage.getItem('selectedClient'),
				warehouseid: window.localStorage.getItem('selectedWarehouse'),
				stocktype: this.stocktype?this.stocktype:null,
				butckettype : bucketType
			}
			if(this.eancode){
				params["eancode"] = this.eancode
			}
			if (csvCheck !== 1) {
				params.offset = (this.currentPage - 1) * this.pageLimit1;
				params.limit = this.pageLimit1;
			}
			Object.entries(params).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					dataFilter[k] = v;
				}
			})
			axios({
				method: 'GET',
				url: `${apiUrl.api_url}bucketwipproducts`,
				params: params,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
			.then(response=>{
				if (csvCheck == 1) {
					this.show = true;
					this.download = false;
					this.listWipSummarycsv = [];
					this.csvFields = {
						'eancode': this.$t('common.ean'),
						'productid': this.$t('orders.skuID'),
						'totalWipInventory':this.$t('wipInventory.totalWipInventory'),
						'grnpendingqty': this.$t('wipInventory.inGrn'),
						'packpedningqty': this.$t('wipInventory.inPacking'),
						'shippedningqty': this.$t('wipInventory.inShipping'),
						'putawaypedningqty': this.$t('wipInventory.inPutaway'),
					};
					
					this.listWipSummarycsv = response.data.data.map((el) => {return { productid:el.productid,eancode:el.eancode,'totalWipInventory':Number(el.grnpendingqty)+Number(el.packpedningqty)+Number(el.shippedningqty)+Number(el.putawaypedningqty),grnpendingqty:el.grnpendingqty,putawaypedningqty:el.putawaypedningqty,packpedningqty:el.packpedningqty,shippedningqty:el.shippedningqty}});
					var dateFilter = [];
					var skipFilter = ['sumcount','packpedningqtysum','shippedningqtysum','grnpendingqtysum','putawaypedningqtysum','rowcount'];
					csvHelper.data.jsonToCSV(this.$t('wipInventory.wipInventorySummaryReport'), this.listWipSummarycsv, this.csvFields, dateFilter, skipFilter, dataFilter);

				} else{
					if(response.data.errorCode != 0){
                        this.resultCount = 0;
						this.totalRows = 0;
						this.listWipInventoryData=[];
						this.totalBucketCount={
							grn : 0,
							putaway: 0,
							packing: 0,
							shipping: 0,
							totalInventory: 0
						};
						this.$alertify.error(response.data.msg);
					}
                   else{
					if(response.data.count>0){
					this.listGRNData = response.data.data;
					// this.calculateBucketWiseCount(this.listGRNData[0]);
                    this.isLoading = false;
					this.totalRows = response.data.count;
					this.resultCount = response.data.count;
					if (this.totalRows < this.pageLimit1) {
						this.totalPage = 1;
					} else {
						this.totalPage = Math.ceil(this.totalRows / this.pageLimit1);
					}
				 }
				 else{
					    this.resultCount = 0;
						this.totalRows = 0;
						this.listGRNData= []
						this.listWipInventoryData=[];
						this.totalBucketCount={
							grn : 0,
							putaway: 0,
							packing: 0,
							shipping: 0,
							totalInventory: 0
						};
				 }
				}
				}
				 this.isLoading = false;
			})
			.catch(error => {
				console.error(error);
			});
		},
		showBucketWiseStock1(){
			this.currentPage1 = 1;
			this.download =true;
			this.show = false;
			this.showBucketWiseProducts(0,this.bucketType);
			
		},
		onPageChange(page){
			this.currentPage1 = page;
			this.showWipInventorySummary();
		},
		onPageChangeBucketWise(page){
			this.currentPage= page;
			this.showBucketWiseProducts(2,this.bucketType);

		},
		downloadwipReport(bucketType){
            var userToken = window.localStorage.getItem('userToken')
            var myStr = userToken.replace(/"/g, '');
            if (window.localStorage.getItem('selectedClient')==='undefined') {
                this.$alertify.error(this.$t('common.clientError'))
                return false;
            }
            if (window.localStorage.getItem('selectedWarehouse')==='undefined') {
				this.$alertify.error(this.$t('common.warehouseError'))
                return false;
            }
            var dataFilter = {};
            // let bucketType= 'in_grn_po';
            let params = {
                clientid: window.localStorage.getItem('selectedClient'),
                warehouseid: window.localStorage.getItem('selectedwarehouse'),
                eancode: this.eancode?this.eancode:null,
                butckettype: bucketType,
                stocktype: this.stocktype?this.stocktype:null,
            };
			console.log("==this.eancode==", this.eancode)
            Object.entries(params).forEach(([k, v]) => {
                let skipkeys = ['butckettype'];
                if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
                    dataFilter[k] = v;
                }
            })
            this.isLoading = true;
            axios({
                method: 'GET',
                url: `${apiUrl.api_url}wipproductdetails`,
                params: params,
                headers: {
                    'Authorization': 'Bearer ' + myStr
                }
            })
             .then(response=>{
				const csvFieldMappings = {
					'in_grn_po': {
					  'productid': 'Product ID',
					  'drid': 'DR ID',
					  'poid': 'poid',
					  'po_grn_pen_qty' : 'Qty'
					},
					'in_grn_returns': {
					  'returntype': 'Returns Type',
					  'orderid': 'Order ID',
					  'awbno': 'AWB No',
					  'quantity': 'Quantity'
					},
					'in_putaway_returns': {
					  'returntype': 'Returns Type',
					  'orderid': 'Order ID',
					  'awbno': 'AWB No',
					  'orderid': 'poid',
					  'putaway_pen_qty': 'Quantity'
					},
					'in_putaway_po': {
					  'productid': 'Product ID',
					  'poid': 'Order Id',
					  'po_putaway_pen_qty': 'Quantity'
					},
					'in_putaway_cancle_modify': {
					  'boxid': 'Box ID',
					  'orderid': 'Order Id',
					  'can_pen_qty': 'Quantity'
					},
					'in_putaway_moveorder': {
					  'boxid': 'Box ID',
					  'moveorderid': 'Order Id',
					  'putaway_pen_qty': 'Quantity'
					},
					'in_packing_order': {
					  'orderid': 'Order Id',
					  'packing_pen_qty': 'Quantity'
					},
					'in_packing_getpass' :  {
						'orderid': 'Order Id',
						'getpass_pen_qty' : 'Quantity'
					},
					'in_shipping_order': {
					'orderid' : 'Order Id',
					  'boxid': 'box id',
					  'packingboxid': 'Packing Box ID',
					  'shippingcompany': 'Courier',
					  'awbno': 'AWB',
					  'manifestid': 'Manifiest ID',
					  'packing_qty': 'Qty'
					  
					}, 
					'in_shipping_getpass' :  {
						'orderid': 'Order Id',
						'packing_qty' : 'Quantity'
					},
					'in_shipping_rtv' :  {
						'orderid': 'Order Id',
						'packing_qty' : 'Quantity'
					},
				  };
                
                var dateFilter = [];
                var skipFilter = ['rowcount'];
				if (csvFieldMappings.hasOwnProperty(bucketType)) {
					this.csvFields = csvFieldMappings[bucketType];
				  }
				  this.packingSalesOrderDataCSV = response.data.data.map(function (el) {
					return this.csvFields ? Object.fromEntries(Object.entries(this.csvFields).map(([key, value]) => [key, el[key]])) : {};
				  }.bind(this));
				
				 csvHelper.data.jsonToCSV("WipnInventory", this.packingSalesOrderDataCSV, this.csvFields, dateFilter, skipFilter, dataFilter);
                this.isLoading = false
             })
             .catch(error => {
                console.error(error);
            })
        },
		downloadbucketwisewipReport(bucketType,csvdata){
			console.log("======832==")
            var userToken = window.localStorage.getItem('userToken')
            var myStr = userToken.replace(/"/g, '');
            if (window.localStorage.getItem('selectedClient')==='undefined') {
                this.$alertify.error(this.$t('common.clientError'))
                return false;
            }
            if (window.localStorage.getItem('selectedWarehouse')==='undefined') {
				this.$alertify.error(this.$t('common.warehouseError'))
                return false;
            }
            var dataFilter = {};
			this.dataFilter2 = [];

            // let bucketType= 'in_grn_po';
			let params = {
				clientid: window.localStorage.getItem('selectedClient'),
				warehouseid:window.localStorage.getItem('selectedWarehouse'),
				//eancode: this.eancode,
				butckettype: bucketType,
				stocktype: this.stocktype?this.stocktype:null,
				offset: 0,
				limit: 0
			}
			if(this.eancode){
				params[ "eancode" ] = this.eancode
			}
			if(csvdata == 1){
				Object.entries(params).forEach(([k, v]) => {
					let skipkeys = ['butckettype'];
					if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
						dataFilter[k] = v;
					}
				})
			}

            if(csvdata ==3){
				var value = '';
				var str = '';
				Object.entries(params).forEach(([k, v]) => {
					let skipkeys = [];
					if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
						value += k + ':' + v + ','
						this.dataFilter2 = str.concat(value);
	
					}
				});
			}
			
            this.isLoading = true;
            axios({
                method: 'GET',
                url: `${apiUrl.api_url}bucketwipproducts`,
                params: params,
                headers: {
                    'Authorization': 'Bearer ' + myStr
                }
            })
             .then(response=>{
				let suminventory = 0;

				response.data.data = response.data.data.map(obj => {
					if(bucketType == 'in_grn'){
						suminventory =  Number(obj.poqty) + Number(obj.rtnqty)
					}
					else if (bucketType == 'in_putaway'){
						suminventory =   Number(obj.poqty) + Number(obj.rtnqty) + Number(obj.moveqty) + Number(obj.cancleqty)
					}
					else if (bucketType == 'in_packing'){
						suminventory =  Number(obj.rtv_pen_qty) + Number(obj.getpass_pen_qty) + Number(obj.packing_pen_qty) 
					}
					else if (bucketType ==  'in_shipping'){
						suminventory =  Number(obj.rtv_pen_qty) + Number(obj.getpass_pen_qty) + Number(obj.packing_pen_qty)
					}
                    return Object.assign({}, obj, { totalWipInventoryKey : suminventory });
                  })

				if(csvdata == 1){		

				const csvFieldMappings = {
					'in_grn': {
						"clientproductid": "SKU ID",
						"eancode": "EAN",						
						"poqty": "PO Qty",
						"rtnqty": "Returns Qty",
						"totalWipInventoryKey": "TotalWipInventory",
					},
					'in_putaway': {
						"clientproductid": "SKU ID",
						"eancode": "EAN",
						"poqty": "PO Qty",
						"moveqty": "Move Qty",	
						"cancleqty": "cancelModifyPutawayQTY",
						"rtnqty": "Returns Qty",
						"totalWipInventoryKey": "TotalWipInventory",
					},
					'in_packing': {
						"clientproductid": "SKU ID",
						"eancode": "EAN",
						"packing_pen_qty": "Sales Order",
						"getpass_pen_qty": "Gatepass",
						"rtv_pen_qty": "RTV",
						"totalWipInventoryKey": "TotalWipInventory",	
					},
					'in_shipping': {
						"eancode": "EAN",
						"clientproductid": "SKU ID",
						"getpass_pen_qty": "Gatepass",
						"packing_pen_qty": "Sales Order",
						"rtv_pen_qty": "RTV",
						"totalWipInventoryKey": "TotalWipInventory",	

					},
				  };
                
                var dateFilter = [];
                var skipFilter = ['rowcount'];
				if (csvFieldMappings.hasOwnProperty(bucketType)) {
					this.csvFields = csvFieldMappings[bucketType];
				  }
				  this.packingSalesOrderDataCSV = response.data.data.map(function (el) {
					return this.csvFields ? Object.fromEntries(Object.entries(this.csvFields).map(([key, value]) => [key, el[key]])) : {};
				  }.bind(this));
				let csvfilename = bucketType+"_WipnInventorybucketwise"
				 csvHelper.data.jsonToCSV(csvfilename, this.packingSalesOrderDataCSV, this.csvFields, dateFilter, skipFilter, dataFilter);
                this.isLoading = false
				}
				 if (csvdata == 3) {
					 this.csvFieldsForXls = [];
					 this.reportname = bucketType+"_WipnInventorybucketwise";
					 this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
			 
					 this.listBucketwiseDataforxls = response.data.data;

					 if (bucketType == 'in_grn') {
						     this.csvFieldsForXls[this.$t('orders.skuID')] = 'clientproductid',
							 this.csvFieldsForXls[this.$t('common.ean')] = 'eancode',
							 this.csvFieldsForXls[this.$t('wipInventory.totalWipInventory')] = 'totalWipInventoryKey',
							 this.csvFieldsForXls[this.$t('PO Qty')] = 'poqty',
							 this.csvFieldsForXls[this.$t('Returns Qty')] = 'rtnqty'
					 }
					 else if (bucketType =='in_putaway') {
						     this.csvFieldsForXls[this.$t('orders.skuID')] = 'clientproductid',
							 this.csvFieldsForXls[this.$t('common.ean')] = 'eancode',
							 this.csvFieldsForXls[this.$t('PO Qty')] = 'poqty',
							 this.csvFieldsForXls[this.$t('Move Qty')] = 'moveqty',
							 this.csvFieldsForXls[this.$t('cancelModifyPutawayQTY')] = 'cancleqty',
							 this.csvFieldsForXls[this.$t('returns Qty')] = 'rtnqty',
							 this.csvFieldsForXls[this.$t('wipInventory.totalWipInventory')] = 'totalWipInventoryKey'
					 }
					 else if (bucketType =='in_packing') {
							 this.csvFieldsForXls[this.$t('orders.skuID')] = 'clientproductid',
							 this.csvFieldsForXls[this.$t('common.ean')] = 'eancode',
							 this.csvFieldsForXls[this.$t('Sales Order')] = 'packing_pen_qty',
							 this.csvFieldsForXls[this.$t('Gatepass')] = 'getpass_pen_qty',
							 this.csvFieldsForXls[this.$t('RTV')] = 'rtv_pen_qty',
							 this.csvFieldsForXls[this.$t('wipInventory.totalWipInventory')] = 'totalWipInventoryKey'
					 }
					 else if (bucketType =='in_shipping') {
					     	 this.csvFieldsForXls[this.$t('orders.skuID')] = 'clientproductid',
							 this.csvFieldsForXls[this.$t('common.ean')] = 'eancode',
							 this.csvFieldsForXls[this.$t('Sales Order')] = 'packing_pen_qty',
							 this.csvFieldsForXls[this.$t('Gatepass')] = 'getpass_pen_qty',
							 this.csvFieldsForXls[this.$t('RTV')] = 'rtv_pen_qty',
							 this.csvFieldsForXls[this.$t('wipInventory.totalWipInventory')] = 'totalWipInventoryKey'
				     }
				 }
				 this.isLoading = false;

             })
             .catch(error => {
                console.error(error);
            })
        },
	
		async wipproductdetailsfunction(eancode,bucketType){
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			let currentPage = 1;
			switch (bucketType) {
				case 'in_packing_order':
					currentPage = this.currentPageInPackingOrder;		
						  break;
				case 'in_packing_rtv':
				  currentPage = this.currentPageInPackingRtv;
				  break;
				case 'in_packing_getpass':
					currentPage = this.currentPageInPackingGetpass;		
				break;
                case 'in_grn_po':
				 currentPage = this.currentPageInGRNPo;
                 break;
				case 'in_grn_returns':
				 currentPage= this.currentPageInGRNReturns;
				 break;
				 case 'in_putaway_po':
				 currentPage= this.currentPageInPutawayPo;
				 break;
                case 'in_putaway_returns':
				currentPage = this.currentPageInPutawayReturns;
				break;
				case 'in_putaway_cancle_modify':
				currentPage = this.currentPageInPutawayCancel;
				break;
				case 'in_putaway_moveorder':
				currentPage = this.currentPageInPutawayMoveOrder;
				break;
				case 'in_shipping_getpass':
				currentPage = this.currentPageInShippingGetpassData;
				break;
				case 'in_shipping_order':
				currentPage = this.currentPageInShippingOrderData;
				break;
				// Add more cases for other bucket types if needed
			  }
			this.isLoading = true;
			let params = {
				clientid: window.localStorage.getItem('selectedClient'),
				warehouseid: window.localStorage.getItem('selectedWarehouse'),
				eancode: eancode,
				butckettype: bucketType,
				stocktype: this.stocktype?this.stocktype:null,
				offset: (currentPage - 1) * this.pageLimit,
				limit: this.pageLimit
			}
			try {
				let response = await axios({
					method: 'GET',
					url: `${apiUrl.api_url}wipproductdetails`,
					params: params,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				});
				switch(bucketType){
					case 'in_packing_order':
						this.packingSalesData= response.data.data;
						this.totalRowsInPackingOrder= response.data.count;
						this.sku = response.data.data.length > 0 && response.data.data[0].clientproductid ? response.data.data[0].clientproductid : this.EANNo
						this.eancode1 =  response.data.data.length > 0 && response.data.data[0].eancode ? response.data.data[0].eancode : this.EANNo
						this.totalQtyInBucket['in_packing_order']= response.data.totalQty;
						if (this.totalRowsInPackingOrder < this.pageLimit) {
									this.totalPageInPackingOrder= 1;
						} else {
									this.totalPageInPackingOrder = Math.ceil(this.totalRowsInPackingOrder / this.pageLimit);
						}
						break;
					case 'in_packing_rtv':
						this.packingRTVData= response.data.data;
						this.sku = response.data.data.length > 0 && response.data.data[0].clientproductid ? response.data.data[0].clientproductid : this.EANNo
						this.eancode1 =  response.data.data.length > 0 && response.data.data[0].eancode ? response.data.data[0].eancode : this.EANNo
				        this.totalRowsInPackingRTV= response.data.count;
						this.totalQtyInBucket['in_packing_rtv']= response.data.totalQty;
				        if (this.totalRowsInPackingRTV < this.pageLimit) {
					    this.totalPageInPackingRTV= 1;
				        } else {
					    this.totalPageInPackingRTV = Math.ceil(this.totalRowsInPackingRTV / this.pageLimit);
				        }
						break;
					case 'in_packing_getpass':
						this.packingGatepassData = response.data.data;
						this.sku = response.data.data.length > 0 && response.data.data[0].clientproductid ? response.data.data[0].clientproductid : this.EANNo
						this.eancode1 =  response.data.data.length > 0 && response.data.data[0].eancode ? response.data.data[0].eancode : this.EANNo
				        this.totalRowsInPackingGetpass= response.data.count;
						this.totalQtyInBucket['in_packing_getpass']=response.data.totalQty;
				        if (this.totalRowsInPackingGetpass < this.pageLimit) {
					     this.totalPageInPackingGetpass= 1;
				        } else {
					     this.totalPageInPackingGetpass = Math.ceil(this.totalRowsInPackingGetpass / this.pageLimit);
					    }
						break;
					case 'in_grn_po':
					    this.GRNPOData= response.data.data;

						this.sku = response.data.data.length > 0 && response.data.data[0].clientproductid ? response.data.data[0].clientproductid : this.EANNo
						this.eancode1 =  response.data.data.length > 0 && response.data.data[0].eancode ? response.data.data[0].eancode : this.EANNo

						// this.sku =response.data.data.length > 0 ? response.data.data[0].clientproductid : ''
						// this.eancode1 = response.data.data.length > 0 ?  response.data.data[0].eancode : ''
						this.totalRowsInGRNPo= response.data.count;
						this.totalQtyInBucket['in_grn_po']= response.data.totalQty;
						if (this.totalRowsInGRNPo < this.pageLimit) {
									this.totalPageInGRNPo= 1;
						} else {
									this.totalPageInGRNPo = Math.ceil(this.totalRowsInGRNPo / this.pageLimit);
						}
					   break;
					case 'in_grn_returns':
						this.GRNReturnsData = response.data.data;
						this.sku = response.data.data.length > 0 && response.data.data[0].clientproductid ? response.data.data[0].clientproductid : this.EANNo
						this.eancode1 =  response.data.data.length > 0 && response.data.data[0].eancode ? response.data.data[0].eancode : this.EANNo

						this.totalRowsInGRNReturns= response.data.count;
						this.totalQtyInBucket['in_grn_returns']= response.data.totalQty;
						if (this.totalRowsInGRNReturns < this.pageLimit) {
									this.totalPageInGRNReturns= 1;
						} else {
									this.totalPageInGRNReturns = Math.ceil(this.totalRowsInGRNReturns / this.pageLimit);
						}
					   break;

					case 'in_putaway_po':
						this.inPutawayPoData = response.data.data;
						this.sku = response.data.data.length > 0 && response.data.data[0].clientproductid ? response.data.data[0].clientproductid : this.EANNo
						this.eancode1 =  response.data.data.length > 0 && response.data.data[0].eancode ? response.data.data[0].eancode : this.EANNo
						this.totalRowsInPutawayPo= response.data.count;
						this.totalQtyInBucket['in_putaway_po']= response.data.totalQty;
                        if(this.selectbucketwise){
						this.totalQtyInBucket['in_putaway_returns']= '';
						this.totalQtyInBucket['in_putaway_cancle_modify']= '';
						this.totalQtyInBucket['in_putaway_moveorder']= '';
                        this.inPutawayCancelOrder=[]	
						this.inPutawayMoveorder=[]
						this.inPutawayReturnsData =[]
                        }
						if (this.totalRowsInPutawayPo < this.pageLimit) {
									this.totalPageInPutawayPo= 1;
						} else {
									this.totalPageInPutawayPo = Math.ceil(this.totalRowsInPutawayPo / this.pageLimit);
						}
					   break;

					case 'in_putaway_returns':
						this.inPutawayReturnsData = response.data.data;
						this.sku = response.data.data.length > 0 && response.data.data[0].clientproductid ? response.data.data[0].clientproductid : this.EANNo
						this.eancode1 =  response.data.data.length > 0 && response.data.data[0].eancode ? response.data.data[0].eancode : this.EANNo
						this.totalRowsInPutawayReturns= response.data.count;
						this.totalQtyInBucket['in_putaway_returns']= response.data.totalQty;
                        if(this.selectbucketwise){
						this.totalQtyInBucket['in_putaway_po']= '';
						this.totalQtyInBucket['in_putaway_cancle_modify']= '';
						this.totalQtyInBucket['in_putaway_moveorder']= '';
                        this.inPutawayCancelOrder=[]	
						this.inPutawayMoveorder=[]
						this.inPutawayPoData=[]
                        }
						if (this.totalRowsInPutawayReturns < this.pageLimit) {
									this.totalPageInPutawayReturns= 1;
						} else {
									this.totalPageInPutawayReturns = Math.ceil(this.totalRowsInPutawayReturns / this.pageLimit);
						}
					   break;
					
					case 'in_putaway_cancle_modify':
						this.inPutawayCancelOrder= response.data.data;
						
						this.sku = response.data.data.length > 0 && response.data.data[0].clientproductid ? response.data.data[0].clientproductid : this.EANNo
						this.eancode1 =  response.data.data.length > 0 && response.data.data[0].eancode ? response.data.data[0].eancode : this.EANNo
						this.totalRowsInPutawayCancel= response.data.count;
						this.totalQtyInBucket['in_putaway_cancle_modify']= response.data.totalQty;
                        if(this.selectbucketwise){
						this.totalQtyInBucket['in_putaway_po']= '';
						this.totalQtyInBucket['in_putaway_returns']= '';
						this.totalQtyInBucket['in_putaway_moveorder']= '';
                        this.inPutawayMoveorder=[]
						this.inPutawayPoData=[]
						this.inPutawayReturnsData=[]
                        }
						if (this.totalRowsInPutawayCancel < this.pageLimit) {
									this.totalPageInPutawayCancel= 1;
						} else {
									this.totalPageInPutawayCancel = Math.ceil(this.totalRowsInPutawayCancel / this.pageLimit);
						}
					   break;

					case 'in_putaway_moveorder':
						this.inPutawayMoveorder= response.data.data;
						
						this.sku = response.data.data.length > 0 && response.data.data[0].clientproductid ? response.data.data[0].clientproductid : this.EANNo
						this.eancode1 =  response.data.data.length > 0 && response.data.data[0].eancode ? response.data.data[0].eancode : this.EANNo
						this.totalRowsInPutawayMoveOrder= response.data.count;
						this.totalQtyInBucket['in_putaway_moveorder']= response.data.totalQty;
                        if(this.selectbucketwise){
						this.totalQtyInBucket['in_putaway_po']= '';
						this.totalQtyInBucket['in_putaway_returns']= '';
						this.totalQtyInBucket['in_putaway_cancle_modify']= '';
                        this.inPutawayPoData=[]
						this.inPutawayReturnsData=[]
						this.inPutawayCancelOrder=[]
                        }
						if (this.totalRowsInPutawayMoveOrder < this.pageLimit) {
									this.totalPageInPutawayMoveOrder= 1;
						} else {
									this.totalPageInPutawayMoveOrder = Math.ceil(this.totalRowsInPutawayMoveOrder / this.pageLimit);
						}
					   break;

					case 'in_shipping_order':
						this.inShippingOrderData= response.data.data;
						this.totalRowsInShippingOrderData= response.data.count;
						
						this.sku = response.data.data.length > 0 && response.data.data[0].clientproductid ? response.data.data[0].clientproductid : this.EANNo
						this.eancode1 =  response.data.data.length > 0 && response.data.data[0].eancode ? response.data.data[0].eancode : this.EANNo
						this.totalQtyInBucket['in_shipping_order']= response.data.totalQty;
                        if(this.selectbucketwise){
						this.totalQtyInBucket['in_shipping_getpass']=''
                        this.inShippingGetpassData = []
                        }
						if (this.totalRowsInShippingOrderData < this.pageLimit) {
									this.totalPageInShippingOrderData= 1;
						} else {
									this.totalPageInShippingOrderData = Math.ceil(this.totalRowsInShippingOrderData / this.pageLimit);
						}
					   break;

					   case 'in_shipping_getpass':
						this.inShippingGetpassData= response.data.data;
					
						this.sku = response.data.data.length > 0 && response.data.data[0].clientproductid ? response.data.data[0].clientproductid : this.EANNo
						this.eancode1 =  response.data.data.length > 0 && response.data.data[0].eancode ? response.data.data[0].eancode : this.EANNo

						this.totalRowsInShippingGetpassData= response.data.count;
						this.totalQtyInBucket['in_shipping_getpass']= response.data.totalQty;
                        if(this.selectbucketwise){
						this.totalQtyInBucket['in_shipping_order'] =''
                        this.inShippingOrderData = []
                        }
						if (this.totalRowsInShippingGetpassData < this.pageLimit) {
									this.totalPageInShippingGetpassData= 1;
						} else {
									this.totalPageInShippingGetpassData= Math.ceil(this.totalRowsInShippingGetpassData / this.pageLimit);
						}
					   break;
				}
				 this.isLoading = false;
			} catch (error) {
				console.error(`Error for bucketType ${bucketType}:`, error);
			}
		},
		async bucketwisedetailsfunction(eancode,bucketType){
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			let currentPage = 1;
			switch (bucketType) {
				case 'in_packing_order':
				  currentPage = this.currentPageInPackingOrder;
				  break;
				case 'in_packing_rtv':
				  currentPage = this.currentPageInPackingRtv;
				  break;
				case 'in_packing_getpass':
				  currentPage = this.currentPageInPackingGetpass;
				  break;
                case 'in_grn_po':
				 currentPage = this.currentPageInGRNPo;
                 break;
				case 'in_grn_returns':
				 currentPage= this.currentPageInGRNReturns;
				 break;
				 case 'in_putaway_po':
				 currentPage= this.currentPageInPutawayPo;
				 break;
                case 'in_putaway_returns':
				currentPage = this.currentPageInPutawayReturns;
				break;
				case 'in_putaway_cancle_modify':
				currentPage = this.currentPageInPutawayCancel;
				break;
				case 'in_putaway_moveorder':
				currentPage = this.currentPageInPutawayMoveOrder;
				break;
				case 'in_shipping_getpass':
				currentPage = this.currentPageInShippingGetpassData;
				break;
				case 'in_shipping_order':
				currentPage = this.currentPageInShippingOrderData;
				break;
				// Add more cases for other bucket types if needed
			  }
			this.isLoading = true;
			let params = {
				clientid: window.localStorage.getItem('selectedClient'),
				warehouseid: window.localStorage.getItem('selectedWarehouse'),
				//eancode: eancode,
				butckettype: bucketType,
				stocktype: this.stocktype?this.stocktype:null,
				offset: (currentPage - 1) * this.pageLimit,
				limit: this.pageLimit
			}
			try {
				let response = await axios({
					method: 'GET',
					url: `${apiUrl.api_url}bucketwipproducts`,
					params: params,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				});
	             
				switch(bucketType){
					case 'in_packing_order':
						this.packingSalesData= response.data.data;
						this.totalRowsInPackingOrder= response.data.count;
						this.totalQtyInBucket['in_packing_order']= response.data.totalQty;
						if (this.totalRowsInPackingOrder < this.pageLimit) {
									this.totalPageInPackingOrder= 1;
						} else {
									this.totalPageInPackingOrder = Math.ceil(this.totalRowsInPackingOrder / this.pageLimit);
						}
						break;
					case 'in_packing_rtv':
						this.packingRTVData= response.data.data;
				        this.totalRowsInPackingRTV= response.data.count;
						this.totalQtyInBucket['in_packing_rtv']= response.data.totalQty;
				        if (this.totalRowsInPackingRTV < this.pageLimit) {
					    this.totalPageInPackingRTV= 1;
				        } else {
					    this.totalPageInPackingRTV = Math.ceil(this.totalRowsInPackingRTV / this.pageLimit);
				        }
						break;
					case 'in_packing_getpass':
						this.packingGatepassData = response.data.data;
				        this.totalRowsInPackingGetpass= response.data.count;
						this.totalQtyInBucket['in_packing_getpass']= response.data.totalQty;
				        if (this.totalRowsInPackingGetpass < this.pageLimit) {
					     this.totalPageInPackingGetpass= 1;
				        } else {
					     this.totalPageInPackingGetpass = Math.ceil(this.totalRowsInPackingGetpass / this.pageLimit);
					    }
						break;
					case 'in_grn_po':
					    this.GRNPOData= response.data.data;
						this.totalRowsInGRNPo= response.data.count;
						this.totalQtyInBucket['in_grn_po']= response.data.totalQty;
						if (this.totalRowsInGRNPo < this.pageLimit) {
									this.totalPageInGRNPo= 1;
						} else {
									this.totalPageInGRNPo = Math.ceil(this.totalRowsInGRNPo / this.pageLimit);
						}
					   break;
					case 'in_grn_returns':
						this.GRNReturnsData = response.data.data;
						this.totalRowsInGRNReturns= response.data.count;
						this.totalQtyInBucket['in_grn_returns']= response.data.totalQty;
						if (this.totalRowsInGRNReturns < this.pageLimit) {
									this.totalPageInGRNReturns= 1;
						} else {
									this.totalPageInGRNReturns = Math.ceil(this.totalRowsInGRNReturns / this.pageLimit);
						}
					   break;
					case 'in_putaway_po':
						this.inPutawayPoData = response.data.data;
						this.totalRowsInPutawayPo= response.data.count;
						this.totalQtyInBucket['in_putaway_po']= response.data.totalQty;
						if (this.totalRowsInPutawayPo < this.pageLimit) {
									this.totalPageInPutawayPo= 1;
						} else {
									this.totalPageInPutawayPo = Math.ceil(this.totalRowsInPutawayPo / this.pageLimit);
						}
					   break;

					case 'in_putaway_returns':
						this.inPutawayReturnsData = response.data.data;
						this.totalRowsInPutawayReturns= response.data.count;
						this.totalQtyInBucket['in_putaway_returns']= response.data.totalQty;
						if (this.totalRowsInPutawayReturns < this.pageLimit) {
									this.totalPageInPutawayReturns= 1;
						} else {
									this.totalPageInPutawayReturns = Math.ceil(this.totalRowsInPutawayReturns / this.pageLimit);
						}
					   break;
					
					case 'in_putaway_cancle_modify':
						this.inPutawayCancelOrder= response.data.data;
						this.totalRowsInPutawayCancel= response.data.count;
						this.totalQtyInBucket['in_putaway_cancle_modify']= response.data.totalQty;
						if (this.totalRowsInPutawayCancel < this.pageLimit) {
									this.totalPageInPutawayCancel= 1;
						} else {
									this.totalPageInPutawayCancel = Math.ceil(this.totalRowsInPutawayCancel / this.pageLimit);
						}
					   break;

					case 'in_putaway_moveorder':
						this.inPutawayMoveorder= response.data.data;
						this.totalRowsInPutawayMoveOrder= response.data.count;
						this.totalQtyInBucket['in_putaway_moveorder']= response.data.totalQty;
						if (this.totalRowsInPutawayMoveOrder < this.pageLimit) {
									this.totalPageInPutawayMoveOrder= 1;
						} else {
									this.totalPageInPutawayMoveOrder = Math.ceil(this.totalRowsInPutawayMoveOrder / this.pageLimit);
						}
					   break;

					case 'in_shipping_order':
						this.inShippingOrderData= response.data.data;
						this.totalRowsInShippingOrderData= response.data.count;
						this.totalQtyInBucket['in_shipping_order']= response.data.totalQty;
						if (this.totalRowsInShippingOrderData < this.pageLimit) {
									this.totalPageInShippingOrderData= 1;
						} else {
									this.totalPageInShippingOrderData = Math.ceil(this.totalRowsInShippingOrderData / this.pageLimit);
						}
					   break;

					   case 'in_shipping_getpass':
						this.inShippingGetpassData= response.data.data;
						this.totalRowsInShippingGetpassData= response.data.count;
						this.totalQtyInBucket['in_shipping_getpass']= response.data.totalQty;
						if (this.totalRowsInShippingGetpassData < this.pageLimit) {
									this.totalPageInShippingGetpassData= 1;
						} else {
									this.totalPageInShippingGetpassData= Math.ceil(this.totalRowsInShippingGetpassData / this.pageLimit);
						}
					   break;
				}
				 this.isLoading = false;
			} catch (error) {
				console.error(`Error for bucketType ${bucketType}:`, error);
			}
		},
		async getbucketdetail(bucketType){
			this.bucketType = bucketType
			this.listGRNData =[],
			this.listPutawayData= [],
			this.listPackingData= [],
			this.listShippingData= []
			this.resultCount = 0
			this.download =true;
			this.show = false;
			this.totalRows = 0
			//this.showBucketWiseProducts(2, bucketType)
		},
		async viewPackingSummary(data){
			this.EANNo = data.eancode;
			this.skuNo= data.productid;
			this.currentPageInPackingOrder=1;
			this.currentPageInPackingRtv=1;
			this.currentPageInPackingGetpass=1;
			let bucketTypes= ["in_packing_order","in_packing_rtv","in_packing_getpass"];
			for (const bucket of bucketTypes) {
				try {
					await this.wipproductdetailsfunction(data.eancode,bucket)
				} catch (error) {
					console.error(`Error for bucketType ${bucket}:`, error);
				}
			}
			this.InPackingBucketDetails= true;
		},
		checktabdetails(wipsumm=''){
         if(wipsumm == 'wipInventorySummary'){
             this.showAlldetails = true
		}else{ 
			this.showAlldetails = false
		}

		},
		async viewGRNSummary(data){
			this.EANNo = data.eancode;
			this.skuNo= data.productid;
            this.currentPageInGRNPo = 1;
			this.currentPageInGRNReturns =1;
		
			let bucketTypes= ["in_grn_po","in_grn_returns"];
			for (const bucket of bucketTypes) {
				try {
					await this.wipproductdetailsfunction(data.eancode,bucket)
				} catch (error) {
					console.error(`Error for bucketType ${bucket}:`, error);
				}
			}
			this.InGRNBucketDetails= true;
		},
		 async viewPutawaySummary(data){
            this.EANNo = data.eancode;
			this.skuNo= data.productid;
			this.currentPageInPutawayPo= 1;
			this.currentPageInPutawayReturns =1;
			this.currentPageInPutawayCancel=1;
            this.currentPageInPutawayMoveOrder=1;

			let bucketTypes= ["in_putaway_po","in_putaway_returns","in_putaway_cancle_modify","in_putaway_moveorder"];
			for (const bucket of bucketTypes) {
				try {
					await this.wipproductdetailsfunction(data.eancode,bucket)
				} catch (error) {
					console.error(`Error for bucketType ${bucket}:`, error);
				}
			}
			this.InPutawayBucketDetails= true;
		 },
		 async viewShippingSummary(data){
			this.EANNo = data.eancode;
			this.skuNo= data.productid;
            this.currentPageInShippingOrderData=1;
			this.currentPageInShippingGetpassData=1;
			let bucketTypes= ["in_shipping_order","in_shipping_getpass"];
			for (const bucket of bucketTypes) {
				try {
					await this.wipproductdetailsfunction(data.eancode,bucket)
				} catch (error) {
					console.error(`Error for bucketType ${bucket}:`, error);
				}
			}
			this.InShippingBucketDetails= true;
		 },
		   onPageChange1(page,bucket){
			switch (bucket) {
				case 'in_packing_order':
				  this.currentPageInPackingOrder = page;
				  break;
				case 'in_packing_rtv':
				  this.currentPageInPackingRtv = page;
				  break;
				case 'in_packing_getpass':
				  this.currentPageInPackingGetpass = page;
				  break;
				case 'in_grn_po':
                  this.currentPageInGRNPo = page;
				  break;
                case 'in_grn_returns':
                  this.currentPageInGRNReturns = page;
				  break;
				case 'in_putaway_po':
				  this.currentPageInPutawayPo = page;
				  break;
				case 'in_putaway_returns':
					this.currentPageInPutawayReturns = page;
					break;
				case 'in_putaway_cancle_modify':
					this.currentPageInPutawayCancel = page;
					break;
				case 'in_putaway_moveorder':
                    this.currentPageInPutawayMoveOrder= page;
				    break;
				case 'in_shipping_order':
					this.currentPageInShippingOrderData= page;
					break;
				case 'in_shipping_getpass':
					this.currentPageInShippingGetpassData= page;
					break;
				// Add more cases for other bucket types 
			  }
			this.wipproductdetailsfunction(this.EANNo,bucket)
			
		},
		resetFormData() {
			this.orderid='';   
			this.totalRows = 0;
			this.totalPage = 0;
			this.resultCount = 0;
			this.ClientErr = "";
			this.WarehouseErr = "";
			this.channellist = [];
			this.selectedRows = {};
			this.listWipInventoryData= [];
			this.offset = 0;
			this.stocktype = '';
			this.eancode ='';	
			this.eancode1 ='';	
			this.searchFlag =false;	
			this.EANNo= '';
			this.listGRNData=[]
			
			this.totalBucketCount={
				grn : 0,
				putaway: 0,
				packing: 0,
				shipping: 0,
				totalInventory: 0
			};
			// if (this.user_type == 'warehouse_user') {
            //     this.client = '';
			// 	this.clientid = '';
			// } else if (this.user_type == 'client_user') {
            //     this.warehouse = '';
			// 	this.warehouseid = '';
			// } else {
            //     this.client = '';
			// 	this.clientid = '';
			// 	this.warehouse = '';
			// 	this.warehouseid = '';
			// }
		},
		resetCommonData(){
			this.selectbucketwise=false
			this.totalRowsInGRNPo=0
			this.totalPageInGRNPo=0
			this.currentPageInGRNPo=1
			this.totalRowsInGRNReturns=0
			this.totalPageInGRNReturns=0
			this.currentPageInGRNReturns=1
			this.GRNReturnsData=[]
			this.GRNPOData=[]
			this.totalPageInPackingOrder=0
			this.totalRowsInPackingOrder=0
            this.currentPageInPackingOrder=1
			this.currentPageInPackingRtv=1
			this.totalRowsInPackingRTV=0
			this.totalPageInPackingRTV=0
			this.totalRowsInPackingGetpass=0
			this.totalPageInPackingGetpass=0
			this.currentPageInPackingGetpass=1
			this.packingSalesData=[]
			this.packingRTVData=[]
			this.packingGatepassData=[]
		}
	}
}


// WEBPACK FOOTER //
// ./src/views/components/wipInventory/wipInventory.component.js